const timeoutPromise = (promise, timeout, error) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(error);
        }, timeout);
        promise.then(resolve, reject);
    });
};

export const fetchTimeout = (url, options = {}, timeout = 7000, error = 'Timeout error') => {
    return timeoutPromise(fetch(url, options), timeout, error);
};
